import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Lista {
  titolo: string;
  sottotitolo: string;
  attivo: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ListService {
  private jsonUrl = '/json/family.json';

  constructor(private http: HttpClient) {}

  getServizi(): Observable<Lista[]> {
    return this.http.get<Lista[]>(this.jsonUrl);
  }
}
